import {
  setSelectedDocumentId,
  setSplitPanelOpen,
  setGaiaObjectType,
} from "./slice";
import { useAppDispatch, useAppSelector } from "app/store";
import { IFilePreviewSplitPanelState } from "./definitions";

export const useFilePreviewSplitPanel = () => {
  const dispatch = useAppDispatch();
  const splitPanel = useAppSelector(
    (state) => state.filePreviewSplitPanel as IFilePreviewSplitPanelState
  );

  return {
    splitPanel,
    setSelectedDocumentId: (payload: string | null) => {
      dispatch(setSelectedDocumentId(payload));
    },
    setSplitPanelOpen: (payload: boolean) => {
      dispatch(setSplitPanelOpen(payload));
    },
    setGaiaObjectType: (payload: string | undefined) => {
      dispatch(setGaiaObjectType(payload));
    },
  };
};
